// src/FeedbackSuccess.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import api from "../utils/api"; // Assuming you have an API utility
import "./FeedbackSuccess.css";

const FeedbackSuccess = () => {
  const { patientUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const appointmentId = urlParams.get("appointmentId");
  const [doctorName, setDoctorName] = useState("Unknown Doctor");

  useEffect(() => {
    const fetchAppointment = async () => {
      if (!appointmentId || !patientUser) return;
      try {
        const response = await api.get(`/appointments/${appointmentId}`, {
          headers: { Authorization: `Bearer ${patientUser.accessToken}` },
        });
        setDoctorName(response.data.doctorId?.name || "Unknown Doctor");
      } catch (err) {
        console.error("Failed to fetch appointment:", err);
      }
    };
    fetchAppointment();
  }, [appointmentId, patientUser]);

  const handleBackToDashboard = () => {
    navigate(patientUser ? `/patient-dashboard/${patientUser.id}` : "/login?type=patient");
  };

  return (
    <div className="feedback-success-container">
      <div className="feedback-success-card">
        <div className="feedback-success-icon">✓</div>
        <h1 className="feedback-success-title">Feedback Sent Successfully</h1>
        <p className="feedback-success-text">
          Your feedback for Dr. {doctorName} has been submitted. Thank you for your input!
        </p>
        <button className="feedback-success-btn" onClick={handleBackToDashboard}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default FeedbackSuccess;